import { Radio, RadioProps } from "@material-ui/core";
import { FieldInputProps } from "formik";
import * as React from "react";

type Props = RadioProps & {
    field: FieldInputProps<string>;
};

export const CustomRadio = ({ value, field }: Props) => {
    return <Radio value={value} name={field.name} onChange={field.onChange} onBlur={field.onBlur} color="primary" />;
};
